import { authenticatedPostRequest } from './authenticatedRequestService';
import envConfig from '../config/environment-config';
import { GetPharmaceutical, UpdatePharmaceuticalParams } from '../pages/portal-pharmaceutical/signup/contracts';
import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { LocalStorageKeysEnum } from '../pages/portal-pharmaceutical/common/contracts';

async function getPharmaceuticalData(programCode: number, healthPassportId: string,) {
  const method = 'pharmaceuticals/consultPharmaceutical';
  const body = {
    programCode,
    healthPassportId,
  };

  return await authenticatedPostRequest(
    method,
    body,
  );
}

function getPharmaceuticalDataWithCache(
  programCode: number,
  healthPassportId: string,
  setCallApi: React.Dispatch<React.SetStateAction<boolean>>,
): UseQueryResult<AxiosResponse<GetPharmaceutical, any>, unknown> {
  const method = 'pharmaceuticals/consultPharmaceutical';
  const body = {
    programCode,
    healthPassportId,
  };
  const staleTime = 60 * 10000; //ms
  const cacheTime = 60 * 10000; //ms

  return useQuery(
    [LocalStorageKeysEnum.PHARMACEUTICAL_DATA, healthPassportId],
    async () => await authenticatedPostRequest(
      method,
      body,
    ),
    {
      onSuccess: () => setCallApi(true),
      staleTime,
      cacheTime
    }
  );
}

async function updatePharmaceuticalData(body: UpdatePharmaceuticalParams) {
  const method = 'pharmaceuticals/update';
  const requestBody = {
    ...body,
    originCode: envConfig.originCode,
  };

  return await authenticatedPostRequest(
    method,
    requestBody,
  );
}

export const pharmaceuticalDataService = {
  getPharmaceuticalData,
  getPharmaceuticalDataWithCache,
  updatePharmaceuticalData,
};
